import { DemeterNewsArticleStatus } from '../../../Generated/Raven-Demeter';

export const STATUS_LABELS: Record<string, string> = {
    [DemeterNewsArticleStatus.New]: 'New',
    [DemeterNewsArticleStatus.PreSelected]: 'Pre-Selected',
    [DemeterNewsArticleStatus.ToReview]: 'To Review',
    [DemeterNewsArticleStatus.ExpertReviewed]: 'Expert Reviewed',
    [DemeterNewsArticleStatus.ArtifileIntelligentReviewed]: 'AI Reviewed',
    [DemeterNewsArticleStatus.Published]: 'Published',
    [DemeterNewsArticleStatus.UnPublished]: 'Unpublished',
    [DemeterNewsArticleStatus.Abandon]: 'Abandoned',
};

export enum ArticleAction {
    Rate = 'Rate',
    Publish = 'Publish',
    Unpublish = 'Unpublish',
    Abandon = 'Abandon',
    Delete = 'Delete',
}

export const ACTION_STATUS_MAP: Partial<Record<ArticleAction, DemeterNewsArticleStatus>> = {
    [ArticleAction.Publish]: DemeterNewsArticleStatus.Published,
    [ArticleAction.Unpublish]: DemeterNewsArticleStatus.UnPublished,
    [ArticleAction.Abandon]: DemeterNewsArticleStatus.Abandon,
};

const ACTION_MAP: Record<string, ArticleAction[]> = {
    [DemeterNewsArticleStatus.New]: [ArticleAction.Rate, ArticleAction.Abandon],
    [DemeterNewsArticleStatus.PreSelected]: [ArticleAction.Rate, ArticleAction.Abandon],
    [DemeterNewsArticleStatus.ToReview]: [ArticleAction.Rate, ArticleAction.Abandon],
    [DemeterNewsArticleStatus.ExpertReviewed]: [ArticleAction.Rate, ArticleAction.Publish, ArticleAction.Abandon],
    [DemeterNewsArticleStatus.ArtifileIntelligentReviewed]: [ArticleAction.Publish, ArticleAction.Abandon],
    [DemeterNewsArticleStatus.Published]: [ArticleAction.Unpublish],
    [DemeterNewsArticleStatus.UnPublished]: [ArticleAction.Publish, ArticleAction.Abandon],
    [DemeterNewsArticleStatus.Abandon]: [ArticleAction.Delete],
};

export const getAvailableActions = (status: DemeterNewsArticleStatus): ArticleAction[] => ACTION_MAP[status] ?? [];

export interface FieldConfidences {
    supply: number | null;
    demand: number | null;
    sentiment: number | null;
}

export const parseFieldConfidences = (comments?: string | null): FieldConfidences => {
    const result: FieldConfidences = { supply: null, demand: null, sentiment: null };
    if (!comments) {
        return result;
    }
    comments.split(/\s+/).forEach((part) => {
        const [key, value] = part.split('=');
        const num = parseFloat(value);
        if (Number.isNaN(num)) {
            return;
        }
        if (key === 'supply') {
            result.supply = num;
        } else if (key === 'demand') {
            result.demand = num;
        } else if (key === 'sentiment') {
            result.sentiment = num;
        }
    });
    return result;
};
